import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3cf5034"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "robotBox" }
const _hoisted_2 = { class: "robotBox-form" }
const _hoisted_3 = { class: "robotBox-checkbox" }
const _hoisted_4 = { class: "robotBox-form" }
const _hoisted_5 = { class: "robotBox-captcha" }
const _hoisted_6 = { class: "robotBox-captcha-input" }
const _hoisted_7 = { class: "robotBox-label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#CA0000","margin-right":"4px"} }, "*", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "robotBox-submit" }

import { ref, computed, watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'robotVerify',
  props: {
  visible: { type: Boolean, required: true, default: false },
},
  emits: [
  'update:visible',
  'success'
],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const { t } = useI18n();



const getLanguageValue = computed(() => store.getters.getLanguageValue);
const dialogWidth = computed(() => getLanguageValue.value == 'en' ? '700px' : '520px');
const dialogShow = computed({
  get: () => props.visible,
  set: (val: boolean) => emit('update:visible', val),
});

const formInfo = ref<any>({})
const noRobotError = ref(false)
const captchaError = ref(false)
const loading = ref(false)
const captchaErrorHint = ref(t('login.input') + t('login.captcha').toLowerCase())

const captchaErrorHintStatusFun = (str = '') => {
  captchaError.value = true
  captchaErrorHint.value = str
}

watch(
  () => formInfo.value.noRobot,
  () => {
    noRobotError.value = !formInfo.value.noRobot
  }
)
watch(
  () => formInfo.value.captcha,
  () => {
    if (!formInfo.value.captcha) {
      captchaErrorHint.value = t('login.input') + t('login.captcha').toLowerCase()
    }
    captchaError.value = !formInfo.value.captcha
  }
)

const onSuccess = () => {
  dialogShow.value = false
  emit('success')
}

const robotCanvas = ref<any>()
const captchaCode = ref('')
const resetImage = () => {
  function generateCaptcha() {
    if (robotCanvas.value) {
      const ctx: any = robotCanvas.value.getContext('2d')
  
      // 生成4位随机数
      captchaCode.value = String(Math.floor(1000 + Math.random() * 9000))
  
      // 清空画布
      ctx.clearRect(0, 0, robotCanvas.value.width, robotCanvas.value.height)
  
      // 绘制背景
      ctx.fillStyle = '#f9f9f9';
      ctx.fillRect(0, 0, robotCanvas.value.width, robotCanvas.value.height)
  
      // 绘制验证码文本
      ctx.font = 'bold 24px Arial'
      ctx.fillStyle = '#333'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(captchaCode.value, robotCanvas.value.width / 2, robotCanvas.value.height / 2)
    }
  }
  // 页面加载时生成验证码
  generateCaptcha()
}

watch(
  dialogShow,
  () => {
    nextTick(() => {
      requestAnimationFrame(() => {
        resetImage()
      })
    })
  },
  { deep: true, immediate: true }
)

const handleSubmit = () => {
  noRobotError.value = !formInfo.value.noRobot
  captchaError.value = !formInfo.value.captcha
  if (!noRobotError.value && !captchaError.value) {
    if (captchaCode.value && captchaCode.value === formInfo.value.captcha) {
      onSuccess()
    } else {
      captchaErrorHintStatusFun(t('login.captchaErrorHint'))
    }
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogShow).value = $event)),
    width: dialogWidth.value,
    "align-center": "",
    title: _ctx.$t('login.noRobotTitle'),
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_checkbox, {
              modelValue: formInfo.value.noRobot,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInfo.value.noRobot) = $event)),
              label: _ctx.$t('login.noRobot'),
              size: "large",
              border: ""
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["robotBox-error", noRobotError.value ? 'robotBox-error-show' : 'robotBox-error-hide'])
          }, _toDisplayString(_ctx.$t('login.noRobot')), 3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.noRobotTwo')), 1)
              ]),
              _createVNode(_component_el_input, {
                required: "",
                class: "baseInputbox",
                style: {"width":"100%"},
                maxlength: 10,
                modelValue: formInfo.value.captcha,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInfo.value.captcha) = $event)),
                placeholder: _ctx.$t('login.input') + _ctx.$t('login.captcha')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", {
              class: "robotBox-canvas",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (resetImage()))
            }, [
              _createElementVNode("canvas", {
                ref_key: "robotCanvas",
                ref: robotCanvas,
                width: "100",
                height: "50"
              }, null, 512),
              _hoisted_9
            ]),
            _createElementVNode("div", {
              class: "robotBox-reset",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (resetImage()))
            }, _toDisplayString(_ctx.$t('login.noRobotReset')), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["robotBox-error", captchaError.value ? 'robotBox-error-show' : 'robotBox-error-hide'])
          }, _toDisplayString(captchaErrorHint.value), 3)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "enter",
            onClick: handleSubmit
          }, _toDisplayString(_ctx.$t('login.contact.submitForm')), 1)
        ])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "width", "title"]))
}
}

})